import { ApiType } from "@gymflow/common";
import { portalIsLocalhost } from "@gymflow/helpers";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { featureFlagOverrideMap } from "libs/types/src/featureFlags";

import { clubAsPublicQueryKeys } from "./clubAsPublicQueryKeys";

export function useClubPropertiesSettingsAsPublic(
  {
    api,
    clubId,
  }: {
    api: ApiType;
    clubId: number;
  },
  opts?: Omit<
    UseQueryOptions<
      | Awaited<
          ReturnType<ApiType["public"]["clubApi"]["propertiesSettings"]>
        >["data"]
      | null
    >,
    "queryKey"
  >,
) {
  return useQuery({
    queryKey: clubAsPublicQueryKeys.propertiesSettings(clubId),
    queryFn: async () => {
      const propertiesSettings = (await api.public.clubApi.propertiesSettings())
        .data;
      const featureFlags = {
        ...propertiesSettings.featureFlags,
        ...(portalIsLocalhost() ? featureFlagOverrideMap.portal : {}),
      };
      return {
        ...propertiesSettings,
        featureFlags,
      };
    },
    enabled: !!clubId,
    placeholderData: null,
    ...opts,
  });
}
